import React from "react";
import { trackEvent } from "../../utils/analytics";
import vuokrattavat from "../../assets/vuokrattavat.webp";
import ResponsiveButton from "../ResponsiveButton/ResponsiveButton";

const RentalHero = () => {
  const scrollToRentalDates = () => {
    trackEvent("rentalhero_valitse_ajankohta_click", {
      sijainti: "vuokrattavat_hero",
    });

    const target = document.getElementById("rental-dates");

    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section
      className="
        relative mx-auto max-w-7xl px-4 pt-24 sm:px-6 lg:px-8
      "
      aria-labelledby="rental-hero-title"
    >
      <div
        className="
          relative overflow-hidden rounded-[2rem] border border-[#DDE7E5]
          bg-white/90 shadow-xl backdrop-blur-xl
          dark:border-darkborder dark:bg-[#111114]/95
        "
      >
        {/* Kuva */}
        <img
          src={vuokrattavat}
          alt="Vuokrattavat äänentoisto- ja tapahtumatekniikan laitteet"
          loading="eager"
          className="
            h-[420px] w-full object-cover
            sm:h-[500px] lg:h-[620px]
          "
        />

        {/* Overlay */}
        <div
          aria-hidden="true"
          className="
            absolute inset-0
            bg-gradient-to-r from-black/85 via-black/55 to-black/10
            dark:from-black/90 dark:via-black/65 dark:to-black/20
          "
        />

        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute -left-20 -top-20 h-72 w-72
            rounded-full bg-primary/20 blur-3xl
          "
        />

        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute bottom-0 right-0 h-72 w-72
            rounded-full bg-primary/10 blur-3xl
          "
        />

        {/* Sisältö */}
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-3xl px-6 sm:px-10 lg:px-12">
            <span
              className="
                mb-5 inline-flex rounded-full border border-primary/40 bg-primary/15
                px-4 py-1.5 font-customFont1 text-xs font-extrabold uppercase
                tracking-[0.14em] !text-white shadow-sm
              "
            >
              Vuokrattavat
            </span>

            <h1
              id="rental-hero-title"
              className="
                font-customFont2 text-5xl font-bold uppercase leading-none
                !text-white
                drop-shadow-[0_4px_18px_rgba(0,0,0,0.65)]
                sm:text-6xl lg:text-7xl
              "
            >
              Vuokrattavat laitteet
            </h1>

            {/* Mobiili */}
            <p
              className="
                mt-5 block max-w-xl font-customFont1 text-base font-semibold
                leading-relaxed !text-white/90
                drop-shadow-[0_3px_12px_rgba(0,0,0,0.65)]
                md:hidden
              "
            >
              Valitse ajankohta ja näe heti vapaat laitteet tapahtumaasi.
            </p>

            {/* Desktop */}
            <p
              className="
                mt-6 hidden max-w-2xl font-customFont1 text-xl font-semibold
                leading-relaxed !text-white/90
                drop-shadow-[0_3px_12px_rgba(0,0,0,0.65)]
                md:block
              "
            >
              Valitse vuokrauksen aloitus- ja lopetuspäivä ja varaa
              äänentoisto-, valo- ja muut tapahtumatekniikan laitteet suoraan
              kalenterista.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <ResponsiveButton
                variant="hero"
                onClick={scrollToRentalDates}
                icon={null}
                className="rounded-full px-8 py-3 text-lg"
              >
                Valitse ajankohta
              </ResponsiveButton>

              <button
                type="button"
                onClick={() => {
                  trackEvent("rentalhero_lue_lisaa_click", {
                    sijainti: "vuokrattavat_hero",
                  });

                  const target = document.getElementById("aanentoisto-title");

                  if (target) {
                    target.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }
                }}
                className="
                  rounded-full border border-white/30 bg-white/10 px-8 py-3
                  font-customFont1 text-base font-extrabold !text-white
                  backdrop-blur-md transition
                  hover:-translate-y-0.5 hover:border-primary hover:bg-primary hover:!text-[#111827]
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary
                "
              >
                Selaa tuotteita
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RentalHero;